module.exports = __webpack_public_path__ + "image_placeholder.d00da1cda69d889cd29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image_placeholder.png
// module id = 693
// module chunks = 0